var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count"},[_c('programme'),_c('attribute'),_c('sources')],1)}
var staticRenderFns = []

export { render, staticRenderFns }